<template>
  <div id="page-business-edit">
    <vs-alert color="danger" title="Business Not Found" :active.sync="notFound">
      <span>Business record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'system-business-list' }" class="text-inherit underline"
          >All Businesses</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="businessData">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('businesses.information')" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <business-edit-tab-information class="mt-4" :data="businessData" />
            </div>
          </vs-tab>
          <vs-tab :label="$t('places.places')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <business-edit-tab-places class="mt-4" :data="businessData" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import BusinessEditTabInformation from './BusinessEditTabInformation'
import BusinessEditTabPlaces from './BusinessEditTabPlaces'

// Store Module
import moduleBusiness from '@/store/business/moduleBusiness.js'

export default {
  name: 'BusinessEdit',
  components: {
    BusinessEditTabPlaces,
    BusinessEditTabInformation
  },
  data() {
    return {
      businessData: null,
      dataLocal: null,
      notFound: false,
      activeTab: 0
    }
  },
  watch: {
    activeTab() {
      this.fetch_business_data()
    }
  },
  methods: {
    fetch_business_data() {
      this.$store
        .dispatch('business/fetchBusiness', this.$route.params.id)
        .then(res => {
          this.businessData = res.data.business
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.notFound = true
          }
        })
    }
  },
  created() {
    // Register Module Business Module
    if (!moduleBusiness.isRegistered) {
      this.$store.registerModule('business', moduleBusiness)
      moduleBusiness.isRegistered = true
    }
    this.fetch_business_data()
  }
}
</script>
